import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {isNeighborhoodDetectiveAvailable} from "@/features/neighborhood_detective/utils/is_neighborhood_detective_available";
import {IPropertyListItemDTO} from "@/features/properties/types/IPropertyListItemDTO";
import {getCurrency} from "@/utils/get_currency";

import {getGtmEcommerceCountry} from "../gtm/ecommerce/types/gtm_ecommerce_country_map";
import {getAmplitudeItemIdProperties} from "./get_amplitude_item_id_properties";

type AmplitudeTrackableProperty = IPropertyListItemDTO | IPropertyDetailDTO;

interface IGetAmplitudePropertyItemParams {
    askOfferCtaVisible?: boolean;
    index?: number;
    property: AmplitudeTrackableProperty;
}

const getRegionStatName = (regionStat?: {name: string} | string | null): string | undefined => {
    if (!regionStat) {
        return undefined;
    }

    return typeof regionStat === "string" ? regionStat : regionStat.name;
};

export const getRegionCategoriesFromFullName = (fullName?: string | null) => {
    if (!fullName) {
        return {item_category3: undefined, item_category4: undefined, item_category5: undefined};
    }

    const parts = fullName
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean);

    if (parts.length < 2) {
        return {item_category3: undefined, item_category4: undefined, item_category5: undefined};
    }

    return {
        item_category3: parts[0],
        item_category4: parts[1],
        item_category5: parts.length >= 3 ? parts[parts.length - 1] : undefined
    };
};

export const getAmplitudePropertyItem = ({property, index, askOfferCtaVisible}: IGetAmplitudePropertyItemParams): Record<string, string | number | boolean> => {
    const offerType = (property.type || property.offer.type) as OfferType;

    const eventProperties: Record<string, string | number | boolean> = {
        ...getAmplitudeItemIdProperties({offerId: property.offer.rp_id || property.offer.gh_id, propertyId: property.rp_id || property.gh_id}),
        item_name: property.offer.name,
        item_brand: property.offer.vendor.name,
        item_category: "property",
        item_category2: getGtmEcommerceCountry(property.region.country),
        item_type: gtmEcommerceOfferTypeMap[offerType],
        variant_name: property.flat_number,
        variant_area: property.area,
        variant_rooms: property.rooms,
        currency: getCurrency({country: property.region.country, ISOCodeFormat: true})
    };

    if (property.offer.address) {
        eventProperties.item_address = property.offer.address;
    }

    if (index != null) {
        eventProperties.index = index;
    }

    if (property.price != null) {
        eventProperties.price = property.price;
    }

    if (property.price_m2 != null) {
        eventProperties.price_m2 = property.price_m2;
    }

    const fromFullName = getRegionCategoriesFromFullName(property.region.full_name);

    const voivodeshipName = fromFullName.item_category3 ?? getRegionStatName(property.region.stats?.region_type_voivodeship);
    if (voivodeshipName) {
        eventProperties.item_category3 = voivodeshipName;
    }

    const cityName = fromFullName.item_category4 ?? getRegionStatName(property.region.stats?.region_type_city);
    if (cityName) {
        eventProperties.item_category4 = cityName;
    }

    const districtName = fromFullName.item_category5 ?? getRegionStatName(property.region.stats?.region_type_district);
    if (districtName) {
        eventProperties.item_category5 = districtName;
    }

    if (property.floor != null) {
        eventProperties.variant_floor = property.floor;
    }

    if (askOfferCtaVisible != null) {
        eventProperties.ask_offer_cta_visible = askOfferCtaVisible;
    }

    eventProperties.km_neighborhood_detective_available = isNeighborhoodDetectiveAvailable(property);

    return eventProperties;
};
import {gtmEcommerceOfferTypeMap, OfferType} from "@pg-rp/common-types";
import {IPropertyDetailDTO} from "@pg-rp/homematch-tinder";

import {isNeighborhoodDetectiveAvailable} from "@/features/neighborhood_detective/utils/is_neighborhood_detective_available";
import {IPropertyListItemDTO} from "@/features/properties/types/IPropertyListItemDTO";
import {getCurrency} from "@/utils/get_currency";

import {getGtmEcommerceCountry} from "../gtm/ecommerce/types/gtm_ecommerce_country_map";
import {getAmplitudeItemIdProperties} from "./get_amplitude_item_id_properties";

type AmplitudeTrackableProperty = IPropertyListItemDTO | IPropertyDetailDTO;

interface IGetAmplitudePropertyItemParams {
    askOfferCtaVisible?: boolean;
    index?: number;
    property: AmplitudeTrackableProperty;
}

const getRegionStatName = (regionStat?: {name: string} | string | null): string | undefined => {
    if (!regionStat) {
        return undefined;
    }

    return typeof regionStat === "string" ? regionStat : regionStat.name;
};

export const getRegionCategoriesFromFullName = (fullName?: string | null) => {
    if (!fullName) {
        return {item_category3: undefined, item_category4: undefined, item_category5: undefined};
    }

    const parts = fullName
        .split(",")
        .map((part) => part.trim())
        .filter(Boolean);

    if (parts.length < 2) {
        return {item_category3: undefined, item_category4: undefined, item_category5: undefined};
    }

    return {
        item_category3: parts[0],
        item_category4: parts[1],
        item_category5: parts.length >= 3 ? parts[parts.length - 1] : undefined
    };
};

export const getAmplitudePropertyItem = ({property, index, askOfferCtaVisible}: IGetAmplitudePropertyItemParams): Record<string, string | number | boolean> => {
    const offerType = (property.type || property.offer.type) as OfferType;

    const eventProperties: Record<string, string | number | boolean> = {
        ...getAmplitudeItemIdProperties({offerId: property.offer.rp_id || property.offer.gh_id, propertyId: property.rp_id || property.gh_id}),
        item_name: property.offer.name,
        item_brand: property.offer.vendor.name,
        item_category: "property",
        item_category2: getGtmEcommerceCountry(property.region.country),
        item_type: gtmEcommerceOfferTypeMap[offerType],
        variant_name: property.flat_number,
        variant_area: property.area,
        variant_rooms: property.rooms,
        currency: getCurrency({country: property.region.country, ISOCodeFormat: true})
    };

    if (property.offer.address) {
        eventProperties.item_address = property.offer.address;
    }

    if (index != null) {
        eventProperties.index = index;
    }

    if (property.price != null) {
        eventProperties.price = property.price;
    }

    if (property.price_m2 != null) {
        eventProperties.price_m2 = property.price_m2;
    }

    const fromFullName = getRegionCategoriesFromFullName(property.region.full_name);

    const voivodeshipName = fromFullName.item_category3 ?? getRegionStatName(property.region.stats?.region_type_voivodeship);
    if (voivodeshipName) {
        eventProperties.item_category3 = voivodeshipName;
    }

    const cityName = fromFullName.item_category4 ?? getRegionStatName(property.region.stats?.region_type_city);
    if (cityName) {
        eventProperties.item_category4 = cityName;
    }

    const districtName = fromFullName.item_category5 ?? getRegionStatName(property.region.stats?.region_type_district);
    if (districtName) {
        eventProperties.item_category5 = districtName;
    }

    if (property.floor != null) {
        eventProperties.variant_floor = property.floor;
    }

    if (askOfferCtaVisible != null) {
        eventProperties.ask_offer_cta_visible = askOfferCtaVisible;
    }

    eventProperties.km_neighborhood_detective_available = isNeighborhoodDetectiveAvailable(property);

    return eventProperties;
};
